{
  "createAccount": "Create account",
  "subscription": "Subscription",
  "oneTimePurchase": "One-Time Purchase",
  "billingDetails": "Billing details",
  "paymentDetails": "Payment details",
  "requestAQuote": "Organization Request Form",
  "reviewOrder": "Review order",
  "thankYouForYourOrder": "Thank you for your order!",
  "joinTheCommunity": "Join the Community",
  "startTrial": "Start Trial",
  "yourTrialHasEnded": "Your trial has ended",
  "taxExempt": "Tax exempt",
  "taxExemptThankYou": "Upload successful!",
  "planDetails": "My subscription details",
  "modifyPlan": "Modify plan",
  "modifyPaymentDetails": "Modify payment details",
  "redirect": "Redirecting to Boardmaker",
  "perpetualTrial": "Download your {{trialLength}}-day free Trial",
  "perpetualThankYou": "Your software is ready!",
  "downloads": "Download Boardmaker",
  "intro": "Select a Boardmaker product below to download the latest version for your device.",
  "partner": "Locate a partner",
  "systemRequirements": "System Requirements",
  "releaseNotes": "Release Notes",
  "comparison": "Compare Subscription and License"
}
